import React, { useState, useCallback, /*useRef,*/ Fragment, useEffect, useContext /*, useMemo*/ } from 'react';
import { Row, Col /*Spinner, OverlayTrigger, Tooltip, Button, ButtonToolbar , Dropdown*/ } from 'react-bootstrap';
import { /*getModalData, getProjectResumeTimesheets,*/ getProjectResumeTotals, getExpenseItemReportability } from '@lib/api';
// import {
// 	IcoCheck,
// 	IcoCheckFailed,
// 	IcoReported,
// 	IcoReportedPartially,
// 	IcoDanger,
// 	IcoArrowClockwise,
// 	IcoDownloadCloudArrowSmall,
// 	ConfirmSolid,
// 	RejectSolid,
// 	BlackPause,
// 	ExclamationBrown,
// } from '@icons';
// import { AgGridReact } from 'ag-grid-react/lib/agGridReact';
// import '@ag-grid-community/core/dist/styles/ag-grid.css';
// import '@ag-grid-community/core/dist/styles/ag-theme-alpine.css';
// import AG_GRID_LOCALE_IT from '@components/ag-grid/locale-it';
// import CustomTooltip from '@components/ag-grid/CustomTooltip';
import {
	// customCellStyle,
	columnToRight,
	columnRightGreen,
	columnRightYellow,
	columnRightRed,
	// columnCentered,
} from '@lib/helpers/agGridHelpers';
import { /*dateFormatter,*/ formatToDecimals } from '@lib/helpers/formatting';
// import OEFilterStaff from 'components/oefilter/OEFilterStaff';
// import ProjectTimesheetModal from 'components/timesheet/projectTimesheetModal';
// import { months } from '@lib/helpers/calendar';
import OESimpleTable from 'components/oetable/OESimpleTable';
// import TimesheetDetailSummaryModal from 'components/summary/TimesheetDetailSummaryModal';
// import CustomPaginationMui from '@components/materialComponents/CustomPaginationMui';
// import CustomQuickFilterBox from 'components/ag-grid/CustomQuickFilterBox';
import { UserContext } from '@components/contexts/UserProvider';
import { useLocation, useParams } from 'react-router-dom';
import NavTabs from '@components/atomic/molecules/NavTabs/NavTabs';
import { Loading } from '@components/atomic/atoms';
import ExecutionSummaryCard from './ExecutionSummaryCard';
// import ModalDownloadReportTimesheets from './Sampling/ModalDownloadReportTimesheets';
import SummaryExternalSupplies from './SummaryExternalSupplies';
import { useQuery /*, useQueryClient*/ } from '@tanstack/react-query';
import { useHasPermission } from '@lib/hooks/useHasPermission';
import SummaryInternalSupplies from './SummaryInternalSupplies';
import Banner from '@components/atomic/atoms/Banner/Banner';

const ExecutionSummary = ({ project }) => {
	const { /*myUser,*/ userAccess /*, isPartnerUser*/ } = useContext(UserContext);
	// const canViewMacroInfo = useHasPermission(['view-control-macro-information']);
	const canViewExternalCosts = useHasPermission(['view-external-costs-tab-control'], 'all');
	const canViewInternalCosts = useHasPermission(['view-internal-costs-tab-control'], 'all');
	const canViewReport = useHasPermission(['access-control-report-tab'], 'all');
	const canViewAIDisclaimer = useHasPermission(['view-ai-disclaimer'], 'all');

	// const [modalData, setModalData] = useState({});

	// const [staff, setStaff] = useState(null);
	// const [staffMeta, setStaffMeta] = useState({});
	const [reports, setReports] = useState(null);
	// const [totals, setTotals] = useState({});
	// const [columnDefsStaff, setColumnDefsStaff] = useState([]);
	const [columnDefsReports, setColumnDefsReports] = useState([]);
	const hasEnabledAi = project?.aiEnabled;

	// const [apiToCall, setApiToCall] = useState('');

	// const [spinnerVisible, setSpinnerVisible] = useState(false);
	// const [refresh, setRefresh] = useState(false);
	// const [isLoading, setIsLoading] = useState(false);
	// const [show, setShow] = useState(false);

	// const [isFiltered, setIsFiltered] = useState(false);
	// const [filteredTotal, setFilteredTotal] = useState(null);

	// const [filterQueryParamsString, setFilterQueryParamsString] = useState('');
	// const [isFirstResearch2, setIsFirstResearch2] = useState(true);

	// const localeText = AG_GRID_LOCALE_IT;
	// const staffRef = useRef(null);
	// const filter1Ref = useRef(null);
	// const filter2Ref = useRef(null);

	// const [showModalDownloadReportTimesheets, setShowModalDownloadReportTimesheets] = useState(false);

	const location = useLocation();
	// const queryClient = useQueryClient();

	// const defaultColDef = {
	// 	resizable: true,
	// 	flex: 1,
	// 	suppressMovable: true,
	// 	cellStyle: {
	// 		padding: '0 1rem',
	// 		textOverflow: 'ellipsis',
	// 		whiteSpace: 'nowrap',
	// 		overflow: 'hidden',
	// 	},
	// 	sortable: true,
	// 	filterParams: {
	// 		suppressAndOrCondition: true, //for disable AND/OR login in filter
	// 		filterOptions: ['contains'],
	// 	},
	// 	suppressCellFocus: false,
	// 	suppressHeaderFocus: false,
	// };

	// const onFilterChanged = (e, reset) => {
	// 	if (!reset) {
	// 		const model = e.api.getFilterModel();

	// 		let queryParamsString = '';

	// 		for (const [key, value] of Object.entries(model)) {
	// 			let keyFormatted = key;

	// 			switch (key) {
	// 				case 'tender':
	// 					keyFormatted = 'tender_number';
	// 					break;
	// 				case 'frameworkContract':
	// 					keyFormatted = 'framework_contract_number';
	// 					break;
	// 				case 'contract':
	// 					keyFormatted = 'contract_number';
	// 					break;
	// 				case 'invoice':
	// 					keyFormatted = 'rp_code';
	// 					break;
	// 				case 'employee.keyValue':
	// 					keyFormatted = 'serial_number';
	// 					break;
	// 				case 'timesheet':
	// 					keyFormatted = 'number';
	// 					break;
	// 				case 'totalCost':
	// 					keyFormatted = 'total_cost';
	// 					break;
	// 				default:
	// 					break;
	// 			}

	// 			queryParamsString += `${queryParamsString === '' ? '?' : '&'}${keyFormatted}=${value.filter}`;
	// 		}

	// 		// if (setModelFilterString) setModelFilterString(queryParamsString);
	// 	} else {
	// 		e?.api?.setFilterModel(null);

	// 		// if (setModelFilterString) setModelFilterString('');
	// 	}
	// };

	// const RefreshButton = () => {
	// 	return (
	// 		<OverlayTrigger placement="top" overlay={<Tooltip>Refresh</Tooltip>}>
	// 			<Button
	// 				onClick={() => {
	// 					setIsLoading(true);
	// 					setTimeout(() => {
	// 						setRefresh(true);
	// 					}, 1000);
	// 				}}
	// 				className="btn custom-ghost-button"
	// 				style={{
	// 					fontWeight: 500,
	// 					fontSize: '18px',
	// 					display: 'flex',
	// 					alignItems: 'flex-start',
	// 					justifyContent: 'center',
	// 					gap: '0.5rem',
	// 				}}
	// 			>
	// 				{isLoading ? (
	// 					<Spinner
	// 						as="span"
	// 						className="mx-1"
	// 						animation="border"
	// 						size="sm"
	// 						role="status"
	// 						aria-hidden="true"
	// 						style={{ verticalAlign: 'middle' }}
	// 					/>
	// 				) : (
	// 					<IcoArrowClockwise />
	// 				)}
	// 				Ricarica dati
	// 			</Button>
	// 		</OverlayTrigger>
	// 	);
	// };

	// const total = (isFilteredDiv, activeKey) => {
	// 	if (activeKey === 'external-supplies') {
	// 		if (isFilteredDiv && isFiltered && filteredTotal) {
	// 			return `${formatToDecimals(filteredTotal.all)} €`;
	// 		} else {
	// 			return `${formatToDecimals(totals.totalFt)} €`;
	// 		}
	// 	}

	// 	if (activeKey === 'intern-workers') {
	// 		if (isFilteredDiv && isFiltered && filteredTotal) {
	// 			return `${formatToDecimals(filteredTotal.all)} €`;
	// 		} else {
	// 			return `${formatToDecimals(totals.totalTs)} €`;
	// 		}
	// 	}
	// };

	// const ofWhichReportable = (isFilteredDiv, indirectCost, activeKey) => {
	// 	if (activeKey === 'external-supplies') {
	// 		//const e = { target: { value: "" } };

	// 		if (isFilteredDiv && isFiltered) {
	// 			const result = indirectCost ? filteredTotal.totalFtIndirect : filteredTotal.rend;
	// 			//onFilterTextBoxChanged(e, externalSuppliesRef);
	// 			return `${formatToDecimals(result)} €`;
	// 		} else {
	// 			//onFilterTextBoxChanged(e, externalSuppliesRef);
	// 			return `${formatToDecimals(totals.totalRendFt)} €`;
	// 		}
	// 	}

	// 	if (activeKey === 'intern-workers') {
	// 		if (isFilteredDiv && isFiltered) {
	// 			const result = indirectCost ? filteredTotal.totalTsIndirect : filteredTotal.rend;

	// 			return `${formatToDecimals(result)} €`;
	// 		} else {
	// 			return `${formatToDecimals(totals.totalRendTs)} €`;
	// 		}
	// 	}
	// };

	// const AvanzamentoCard = () => {
	// 	return (
	// 		<ExecutionSummaryCard
	// 			title="Avanzamento"
	// 			items={[
	// 				{
	// 					key: 'total',
	// 					label: 'Spesa effettuata:',
	// 					value: formatToDecimals(totals.total) + ' €',
	// 				},
	// 				{
	// 					key: 'eligible',
	// 					label: 'Di cui eleggibile:',
	// 					value: formatToDecimals(totals.totalRend) + ' €',
	// 				},
	// 			]}
	// 		/>
	// 	);
	// };
	const projectId = useParams().projectId;

	const { data: totals /*, refetch: refetchTotals*/ } = useQuery({
		queryKey: ['totals', projectId],
		queryFn: () => getProjectResumeTotals(projectId),
		select: (resp) => resp.data,
		// enabled: false,
	});

	const tabNavItems = [
		...(canViewExternalCosts
			? [
					{
						title: 'Costi esterni',
						eventKey: 'external-supplies',
						content: <SummaryExternalSupplies project={project} />,
					},
				]
			: []),
		...(canViewInternalCosts
			? [
					{
						title: 'Costi interni',
						eventKey: 'intern-workers',
						content: (
							<SummaryInternalSupplies project={project} />
							// <Fragment>
							// 	{userAccess.isAboveAuditor ? (
							// 		<Row
							// 			className="align-items-center mb-3"
							// 			style={{
							// 				marginTop: '13px',
							// 			}}
							// 		>
							// 			{canViewMacroInfo ? (
							// 				<Row>
							// 					<Col>
							// 						<AvanzamentoCard />
							// 					</Col>
							// 					<Col>
							// 						<ExecutionSummaryCard
							// 							title="Costi Interni"
							// 							items={[
							// 								{
							// 									key: 'intern-workers-expenses',
							// 									label: 'Spesa in costi interni:',
							// 									value: total(false, 'intern-workers'),
							// 								},
							// 								{
							// 									key: 'intern-workers-eligible',
							// 									label: 'Di cui eleggibile:',
							// 									value: ofWhichReportable(false, true, 'intern-workers'),
							// 								},

							// 								...(!!project.sco
							// 									? [
							// 											{
							// 												key: 'intern-workers-indirect-costs',
							// 												label: 'Costi indiretti',
							// 												value: formatToDecimals(totals.totalTsIndirect) + ' €',
							// 											},
							// 										]
							// 									: []),
							// 							]}
							// 						/>
							// 					</Col>
							// 					<Col>
							// 						<ExecutionSummaryCard
							// 							title="Filtro"
							// 							items={[
							// 								{
							// 									key: 'intern-workers-filtered',
							// 									label: 'Spesa filtrata:',
							// 									value: total(true, 'intern-workers'),
							// 								},
							// 								{
							// 									key: 'intern-workers-filtered-eligible',
							// 									label: 'Di cui eleggibile:',
							// 									value: ofWhichReportable(true, true, 'intern-workers'),
							// 								},
							// 								...(!!project.sco
							// 									? [
							// 											{
							// 												key: 'intern-workers-indirect-costs',
							// 												label: 'Costi indiretti',
							// 												value: isFiltered
							// 													? ofWhichReportable(true, true, 'intern-workers')
							// 													: formatToDecimals(totals.totalTsIndirect) + ' €',
							// 											},
							// 										]
							// 									: []),
							// 							]}
							// 						/>
							// 					</Col>
							// 				</Row>
							// 			) : null}

							// 			<Row
							// 				style={{
							// 					marginTop: '3rem',
							// 					marginBottom: '2rem',
							// 				}}
							// 			>
							// 				<Col className="col-4">
							// 					<CustomQuickFilterBox
							// 						tableRef={staffRef}
							// 						dataMeta={staffMeta}
							// 						setData={setStaff}
							// 						dataLength={staff?.length}
							// 						isFirstResearch={isFirstResearch2}
							// 						setIsFirstResearch={setIsFirstResearch2}
							// 						refTable="staff"
							// 						isRefreshing={isLoading}
							// 						setIsRefreshing={setIsLoading}
							// 					/>
							// 				</Col>
							// 				<Col className="col-8 text-right py-1">
							// 					<ButtonToolbar className="justify-content-end align-items-center" style={{ height: '38px', gap: '0.5rem' }}>
							// 						<RefreshButton />
							// 						<OEFilterStaff
							// 							columnDefs={columnDefsStaff}
							// 							projectId={project.id}
							// 							setTable={setStaff}
							// 							setTableMeta={setStaffMeta}
							// 							isFiltered={isFiltered}
							// 							setIsFiltered={setIsFiltered}
							// 							setFilteredTotal={setFilteredTotal}
							// 							handleClick={() => handleClick(filter2Ref)}
							// 							setFilterQueryParamsString={setFilterQueryParamsString}
							// 							tableRef={staffRef}
							// 							ref={filter2Ref}
							// 						/>
							// 						<Button
							// 							onClick={() => {
							// 								setShowModalDownloadReportTimesheets(true);
							// 							}}
							// 							className="btn custom-ghost-button"
							// 							style={{
							// 								fontWeight: 500,
							// 								fontSize: '18px',
							// 								display: 'flex',
							// 								alignItems: 'center',
							// 								justifyContent: 'center',
							// 								gap: '0.5rem',
							// 							}}
							// 						>
							// 							<IcoDownloadCloudArrowSmall fill="#1C2743" />

							// 							<span style={{ translate: '0 1px' }}>Scarica</span>
							// 						</Button>

							// 						<ModalDownloadReportTimesheets
							// 							filterQueryParamsString={filterQueryParamsString}
							// 							projectId={project.id}
							// 							setShowModalDownloadReportTimesheets={setShowModalDownloadReportTimesheets}
							// 							showModalDownloadReportTimesheets={showModalDownloadReportTimesheets}
							// 						/>
							// 					</ButtonToolbar>
							// 				</Col>
							// 			</Row>
							// 		</Row>
							// 	) : null}

							// 	{Array.isArray(staff) ? (
							// 		<Row className="mb-5">
							// 			<Col className="col-12 col-xxl-9" id="grid-wrapper">
							// 				{Object.keys(staffMeta).length > 0 ? (
							// 					<div className="ag-theme-alpine list-table" style={{ height: '800px' }}>
							// 						<AgGridReact
							// 							ref={staffRef}
							// 							columnDefs={columnDefsStaff}
							// 							rowData={staff}
							// 							defaultColDef={defaultColDef}
							// 							tooltipShowDelay={0}
							// 							tooltipHideDelay={2000}
							// 							tooltipMouseTrack={true}
							// 							onFilterChanged={onFilterChanged}
							// 							headerHeight={50}
							// 							rowHeight={50}
							// 							ariaDescription="ag-grid-table"
							// 							suppressCellFocus={true}
							// 							autoSizeStrategy={{ type: 'fitCellContents' }}
							// 							rowSelection="single"
							// 							localeText={localeText}
							// 						/>
							// 						{Object.keys(staffMeta).length > 0 && (
							// 							<CustomPaginationMui
							// 								dataMeta={staffMeta}
							// 								setData={setStaff}
							// 								setDataMeta={setStaffMeta}
							// 								refTable="staff"
							// 								setIsFirstResearch={setIsFirstResearch2}
							// 							/>
							// 						)}
							// 					</div>
							// 				) : (
							// 					<Row className="text-center my-5">
							// 						<span>Non sono presenti elementi caricati</span>
							// 					</Row>
							// 				)}
							// 			</Col>
							// 		</Row>
							// 	) : (
							// 		<Loading fixedHeight="50vh" />
							// 	)}
							// </Fragment>
						),
					},
				]
			: []),
		...(canViewReport
			? [
					{
						title: 'Report',
						eventKey: 'report',
						shouldBeVisible: userAccess.isAboveAuditor,
						content: (
							<>
								<Row
									className="align-items-center mb-3"
									style={{
										marginTop: '13px',
									}}
								>
									<Col xs={4}>
										<ExecutionSummaryCard
											title="Avanzamento"
											items={[
												{
													key: 'total',
													label: 'Spesa effettuata:',
													value: formatToDecimals(totals?.total) + ' €',
												},
												{
													key: 'eligible',
													label: 'Di cui eleggibile:',
													value: formatToDecimals(totals?.totalRend) + ' €',
												},
											]}
										/>
									</Col>
								</Row>
								{!Array.isArray(reports) ? (
									<Loading fixedHeight="50vh" />
								) : (
									<Row>
										<Col className="col-12">
											<OESimpleTable
												columnDefs={columnDefsReports}
												rowData={reports}
												buttonToolbarVisible={true}
												pageSizeId={'reports-table'}
												sortable={true}
												pinnedBottomRow={true}
												bottomColumns={[{ projectNoticeExpenseItemName: 'TOTALE' }, 'totalColors', 'totalGreen', 'totalYellow', 'totalRed']}
												fullWidth={true}
											/>
										</Col>
									</Row>
								)}
							</>
						),
					},
				]
			: []),
	];

	const activeKey = location.hash
		? location.hash.replace('#', '')
		: tabNavItems.filter((tabNavItem) => !('shouldBeVisible' in tabNavItem) || tabNavItem.shouldBeVisible)[0].eventKey;

	// useEffect(() => {
	// 	if (totalsFromApi) {
	// 		setTotals(totalsFromApi);
	// 	}
	// }, [totalsFromApi]);

	const loadData = useCallback(() => {
		if (project.id) {
			switch (activeKey) {
				// case 'external-supplies':
				// 	getProjectResumeInvoices(project.id, undefined, 'externalSupplies').then((retrievedResults) => {
				// 		if (retrievedResults.success) {
				// 			setExternalSupplies(retrievedResults.data);
				// 			const { data, success, ...restResp } = retrievedResults;
				// 			setExternalSuppliesMeta(restResp);
				// 		}
				// 	});

				// 	break;
				// case 'intern-workers':
				// 	getProjectResumeTimesheets(project.id, undefined, 'staff').then((retrievedResults) => {
				// 		if (retrievedResults.success) {
				// 			setStaff(retrievedResults.data);
				// 			const { data, success, ...restResp } = retrievedResults;
				// 			setStaffMeta(restResp);
				// 		}
				// 	});

				// 	break;
				case 'report':
					getExpenseItemReportability(project.id).then((retrievedResults) => {
						if (retrievedResults.success) {
							let finalMockReport = [];
							retrievedResults.data.forEach((elDB) => {
								//Vedo se trovo un duplicato in base agli id voce e sottovoce
								const res = finalMockReport.filter((elRes) => elRes.projectNoticeExpenseItemId === elDB.projectNoticeExpenseItemId);

								//Se non trova nulla, allora crea un nuovo oggetto
								if (res.length === 0) {
									finalMockReport.push({
										projectNoticeExpenseItemId: elDB.projectNoticeExpenseItemId,
										projectNoticeExpenseItemName: elDB.projectNoticeExpenseItemName,
										projectNoticeExpenseItemPosition: elDB.projectNoticeExpenseItemPosition,
										projectId: elDB.projectId,
										reportability: [
											{
												reportabilityColor: elDB.reportabilityColor,
												amount: elDB.reportabilityColor === 'green' ? elDB.reportableAmount : elDB.amount,
												projectExpenseItemId: elDB.projectExpenseItemId,
												projectExpenseItemName: elDB.projectExpenseItemName,
												projectExpenseItemPosition: elDB.projectExpenseItemPosition,
											},
										],
									});

									//Se lo trova, aggiungi colore e valore all'oggetto trovato
								} else {
									finalMockReport[finalMockReport.indexOf(res[0])].reportability.push({
										reportabilityColor: elDB.reportabilityColor,
										amount: elDB.reportabilityColor === 'green' ? elDB.reportableAmount : elDB.amount,
										projectExpenseItemId: elDB.projectExpenseItemId,
										projectExpenseItemName: elDB.projectExpenseItemName,
										projectExpenseItemPosition: elDB.projectExpenseItemPosition,
									});
								}
							});

							finalMockReport.forEach((el, index) => {
								finalMockReport[index].totalGreen = el.reportability
									.filter((el) => el.reportabilityColor === 'green')
									.reduce((prev, curr) => prev + curr.amount, 0);
								finalMockReport[index].totalYellow = el.reportability
									.filter((el) => el.reportabilityColor === 'yellow')
									.reduce((prev, curr) => prev + curr.amount, 0);
								finalMockReport[index].totalRed = el.reportability
									.filter((el) => el.reportabilityColor === 'red')
									.reduce((prev, curr) => prev + curr.amount, 0);
								finalMockReport[index].totalColors = el.reportability.reduce((prev, curr) => prev + curr.amount, 0);
							});

							finalMockReport = finalMockReport.sort(
								(valueA, valueB) => valueA.projectNoticeExpenseItemPosition - valueB.projectNoticeExpenseItemPosition,
							);

							setReports(finalMockReport);
						}
					});

					break;
				default:
					break;
			}

			// getProjectResumeTotals(project.id).then((retrievedTotals) => {
			// 	if (retrievedTotals.success) {
			// 		setTotals(retrievedTotals.data);
			// 	}
			// });
			// refetchTotals().then((retrievedTotals) => {
			// 	console.log('retrievedTotals', retrievedTotals);
			// 	setTotals(retrievedTotals.data);
			// });
		}
	}, [project.id, activeKey /*, refetchTotals*/]);

	useEffect(() => {
		if (project.id) {
			loadData();
		}
	}, [loadData, project.id]);

	// useEffect(() => {
	// 	if (refresh) {
	// 		loadData();

	// 		setRefresh(false);
	// 		queryClient.invalidateQueries({ queryKey: ['totals', projectId] });
	// 	}
	// }, [loadData, refresh, queryClient, projectId]);

	// const fetchData = async (url) => {
	// 	setSpinnerVisible(true);
	// 	try {
	// 		const response = await getModalData(url);
	// 		setModalData(response.data);
	// 	} catch (error) {
	// 		console.error('Error fetching data:', error);
	// 	}
	// 	setSpinnerVisible(false);
	// };

	// const renderCorrectModal = (modalToRender) => {
	// 	switch (modalToRender) {
	// 		case 'number':
	// 			return userAccess.isPartner ? (
	// 				<ProjectTimesheetModal
	// 					data={modalData}
	// 					setModalIsVisible={setShow}
	// 					modalIsVisible={show}
	// 					isSummary
	// 					spinnerVisible={spinnerVisible}
	// 					setModalData={setModalData}
	// 					setRefresh={setRefresh}
	// 					isProjectSco={project.sco}
	// 				/>
	// 			) : (
	// 				<TimesheetDetailSummaryModal
	// 					data={modalData}
	// 					setModalIsVisible={setShow}
	// 					modalIsVisible={show}
	// 					isSummary
	// 					spinnerVisible={spinnerVisible}
	// 					setModalData={setModalData}
	// 					setRefresh={setRefresh}
	// 					isProjectSco={project.sco}
	// 				/>
	// 			);
	// 		default:
	// 	}
	// };

	// const TotalResumeChecklistCellRenderer = useCallback((params) => {
	// 	//console.log('params', params);

	// 	const red = '#C94723';
	// 	const green = '#689689';
	// 	const yellow = '#D4BE31';
	// 	let stoplightColor = green;
	// 	let isRendicontable = false;
	// 	let isStoplightYellow = false;

	// 	if (params.value && params.data) {
	// 		const arrayEntities = ['tender', 'frameworkContract', 'contract', 'invoice', 'payment', 'timesheet'];

	// 		arrayEntities.forEach((entity) => {
	// 			if (params.data[entity]?.checkliststatus && params.data[entity]?.checkliststatus.color === 'green_white') {
	// 				stoplightColor = yellow;
	// 				isStoplightYellow = true;
	// 			}
	// 		});

	// 		isRendicontable = true;
	// 	} else {
	// 		stoplightColor = red;
	// 		isRendicontable = false;
	// 	}

	// 	const reportableTooltip = (props) => (
	// 		<Tooltip {...props}>{isRendicontable ? (isStoplightYellow ? 'Eleggibile - da validare' : 'Eleggibile') : 'Non eleggibile'}</Tooltip>
	// 	);

	// 	return (
	// 		<OverlayTrigger placement="top" overlay={reportableTooltip}>
	// 			<Row className="align-items-center justify-content-center h-100">
	// 				<Col className="col-auto text-center">
	// 					{isRendicontable ? <IcoCheck style={{ fill: stoplightColor }} /> : <IcoCheckFailed style={{ fill: stoplightColor }} />}
	// 				</Col>
	// 			</Row>
	// 		</OverlayTrigger>
	// 	);
	// }, []);

	// const ResumeChecklistCellRenderer = useCallback(
	// 	(params) => {
	// 		if (params.value && params?.value.keyValue) {
	// 			//console.log('CL color:', params.value?.checkliststatus?.color);
	// 			let message = '';
	// 			let icon = null;

	// 			if (params.value.checkliststatus) {
	// 				let checklistColor = params.value.checkliststatus.color;
	// 				let isGARA = false;

	// 				if (
	// 					params?.queryParam === 'tender_number' &&
	// 					(params.value.key.keyValue?.startsWith('GARATEMP_') || params.value.key.keyValue?.startsWith('GARA_'))
	// 				) {
	// 					isGARA = true;
	// 					checklistColor = params.value.key.keyValue?.startsWith('GARATEMP_')
	// 						? 'yellow'
	// 						: params.value.key.keyValue?.startsWith('GARA_')
	// 							? 'grey'
	// 							: params.value?.checkliststatus?.color;
	// 				}

	// 				switch (checklistColor) {
	// 					case 'green':
	// 						icon = <ConfirmSolid width="1.3em" height="1.3em" />;
	// 						message = 'Conforme';
	// 						break;
	// 					case 'green_white':
	// 						icon = <ConfirmSolid width="1.3em" height="1.3em" />;
	// 						message = 'Conforme - da validare';
	// 						break;
	// 					case 'green_white_settled':
	// 						icon = <ConfirmSolid width="1.3em" height="1.3em" />;
	// 						message = 'Conforme - validato';
	// 						break;
	// 					case 'yellow':
	// 						icon = <RejectSolid width="1.3em" height="1.3em" />;
	// 						message = isGARA ? 'Non ancora disponibile' : 'Incompleta';
	// 						break;
	// 					case 'red':
	// 						icon = <RejectSolid width="1.3em" height="1.3em" />;
	// 						message = 'Non conforme';
	// 						break;
	// 					case 'grey':
	// 					case 'gray':
	// 						icon = <BlackPause width="1.3em" height="1.3em" />;
	// 						message = isGARA ? 'Non applicabile' : 'In lavorazione';
	// 						break;
	// 					case 'white':
	// 						icon = null;
	// 						break;
	// 					default:
	// 						break;
	// 				}
	// 			}

	// 			let value;

	// 			if (params.value.key === 'tender_number' && params.value.keyValue.startsWith('GARA_')) {
	// 				value = 'N.A.';
	// 			} else if (params.value.key === 'tender_number' && params.value.keyValue.startsWith('GARATEMP_')) {
	// 				value = 'N.D.';
	// 			} else {
	// 				value = params.value.keyValue;
	// 			}

	// 			const canBeLink = () => {
	// 				if (project.streamConfigurationType === 'STREAM') {
	// 					return true;
	// 				}

	// 				return false;
	// 			};

	// 			const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

	// 			return (
	// 				<>
	// 					<Row className="align-items-center justify-content-between h-100 flex-nowrap">
	// 						{/* {isActiveSampling && !isCompleteList ? ( */}
	// 						<>
	// 							<Col xs="auto" className="pe-1">
	// 								{icon ? (
	// 									<>
	// 										<OverlayTrigger placement="top" overlay={<Tooltip>{message}</Tooltip>}>
	// 											{icon}
	// 										</OverlayTrigger>
	// 									</>
	// 								) : null}
	// 							</Col>
	// 						</>
	// 						{/* ) : null} */}
	// 						<Col
	// 							className={
	// 								// isActiveSampling && !isCompleteList ?
	// 								'overflow-hidden ps-0'
	// 								//  : ''
	// 							}
	// 						>
	// 							<ConditionalWrapper
	// 								condition={params.link && !params.value.keyValue.startsWith('GARA_' || 'GARATEMP_') && canBeLink()}
	// 								wrapper={(children) => (
	// 									<Button
	// 										variant="link"
	// 										className="d-flex align-items-start projectModalRenderBtn"
	// 										style={{ color: '#1C2743' }}
	// 										onClick={() => {
	// 											setApiToCall(params.value.key);
	// 											fetchData(params.value.href.url);
	// 											// modalDataMutation.mutate(params.value.href.url);
	// 											// modalDataMutationMutateMemo(params.value.href.url);
	// 											params.setShow(true);
	// 										}}
	// 									>
	// 										{children}
	// 									</Button>
	// 								)}
	// 							>
	// 								<span>
	// 									{Object.values(params.data).find((value) => value.key === params.value.key)?.hasDocuments === false ? (
	// 										<OverlayTrigger placement="top" overlay={<Tooltip>Documento mancante</Tooltip>}>
	// 											<ExclamationBrown fill="#995C00" className="me-2" />
	// 										</OverlayTrigger>
	// 									) : null}
	// 									{params.value.keyValue ? (
	// 										typeof params.value.keyValue === 'number' ? (
	// 											formatToDecimals(params.data.taxableAmount) + ' €'
	// 										) : (
	// 											value
	// 										)
	// 									) : (
	// 										<>&zwnj;</>
	// 									)}
	// 								</span>
	// 							</ConditionalWrapper>
	// 						</Col>
	// 					</Row>
	// 				</>
	// 			);
	// 		}
	// 	},
	// 	[/*isActiveSampling,*/ project.streamConfigurationType /* ,isCompleteList*/],
	// );

	// const OnlyChecklistCellRenderer = useCallback((params) => {
	// 	//console.log('params.value', params.value);
	// 	const paramsValue = params?.value;

	// 	if (paramsValue) {
	// 		const stoplightColor = {
	// 			red: '#C94723',
	// 			yellow: '#D4BE31',
	// 			green: '#689689',
	// 			white: '#ffffff',
	// 			gray: '#C4C4C4',
	// 			grey: '#C4C4C4',
	// 			green_white: '#689689',
	// 		};

	// 		let circleStyle;
	// 		let message = '';

	// 		if (!paramsValue) {
	// 			circleStyle = {
	// 				display: 'inherit',
	// 				width: '1.2em',
	// 				height: '1.2em',
	// 				borderRadius: '2em',
	// 				MozBorderRadius: '2em',
	// 				WebkitBorderRadius: '2em',
	// 				backgroundColor: '#ffffff',
	// 				border: `2px solid ${'#C4C4C4'}`,
	// 			};

	// 			message = 'Da lavorare';
	// 		} else {
	// 			if (paramsValue === 'green_white') {
	// 				circleStyle = {
	// 					display: 'inherit',
	// 					width: '23px',
	// 					height: '23px',
	// 					border: '4px solid #689689',
	// 					borderRadius: '50%',
	// 					padding: '0px',
	// 					background: 'linear-gradient(to right, #689689 50%, transparent 0)',
	// 					boxSizing: 'border-box',
	// 				};

	// 				message = 'Conforme - validata';
	// 			} else {
	// 				circleStyle = {
	// 					display: 'inherit',
	// 					width: '1.2em',
	// 					height: '1.2em',
	// 					borderRadius: '2em',
	// 					MozBorderRadius: '2em',
	// 					WebkitBorderRadius: '2em',
	// 					backgroundColor: stoplightColor[paramsValue],
	// 					border: `2px solid ${paramsValue === 'white' ? stoplightColor.grey : stoplightColor[paramsValue]}`,
	// 				};

	// 				switch (paramsValue) {
	// 					case 'white':
	// 						message = 'Non lavorata';
	// 						break;
	// 					case 'grey':
	// 					case 'gray':
	// 						message = 'In lavorazione';
	// 						break;
	// 					case 'red':
	// 						message = 'Non conforme';
	// 						break;
	// 					case 'yellow':
	// 						message = 'Incompleta';
	// 						break;
	// 					case 'green':
	// 						message = 'Conforme';
	// 						break;
	// 					default:
	// 						break;
	// 				}
	// 			}
	// 		}

	// 		return (
	// 			<>
	// 				<Row
	// 					className="align-items-center justify-content-center h-100 flex-nowrap"
	// 					//style={{ justifyContent: params.align ?? "justify-content-between"}}
	// 				>
	// 					<Col className="col-auto">
	// 						<OverlayTrigger placement="top" overlay={<Tooltip>{message}</Tooltip>}>
	// 							<i style={{ ...circleStyle }} />
	// 						</OverlayTrigger>
	// 					</Col>
	// 				</Row>
	// 			</>
	// 		);
	// 	}
	// }, []);

	// const OnlyWarningCellRenderer = useCallback((params) => {
	// 	const paramsValue = params?.value; //bool
	// 	let icon;
	// 	let message = '';
	// 	//console.log('paramsValue', paramsValue);

	// 	if (typeof paramsValue === 'boolean') {
	// 		if (paramsValue) {
	// 			//icona warning
	// 			icon = <IcoDanger />;
	// 			message = 'Attenzione';
	// 		} else {
	// 			//spunta verde
	// 			message = 'Conforme';
	// 			icon = <IcoCheck style={{ fill: '#689689' }} />;
	// 		}

	// 		return (
	// 			<>
	// 				<Row
	// 					className="align-items-center justify-content-center h-100 flex-nowrap"
	// 					//style={{ justifyContent: params.align ?? "justify-content-between"}}
	// 				>
	// 					<Col className="col-auto">
	// 						<OverlayTrigger placement="top" overlay={<Tooltip>{message}</Tooltip>}>
	// 							<span>{icon}</span>
	// 						</OverlayTrigger>
	// 					</Col>
	// 				</Row>
	// 			</>
	// 		);
	// 	}
	// }, []);

	// const ReportedCheckRenderer = useCallback((params) => {
	// 	const reporting = params?.data?.reporting;
	// 	const reported = params?.data?.reported;
	// 	const reportedTooltip = (props) => <Tooltip {...props}>Rendicontato</Tooltip>;
	// 	const partialTooltip = (props) => <Tooltip {...props}>Parzialmente Rendicontato</Tooltip>;
	// 	return (
	// 		<>
	// 			{reporting && (
	// 				<OverlayTrigger placement="top" overlay={partialTooltip}>
	// 					<Row className="align-items-center justify-content-center h-100">
	// 						<Col className="col-auto text-center">
	// 							<IcoReportedPartially />
	// 						</Col>
	// 					</Row>
	// 				</OverlayTrigger>
	// 			)}
	// 			{reported && !reporting && (
	// 				<OverlayTrigger placement="top" overlay={reportedTooltip}>
	// 					<Row className="align-items-center justify-content-center h-100 px-0">
	// 						<Col className="col-auto text-center">
	// 							<IcoReported />
	// 						</Col>
	// 					</Row>
	// 				</OverlayTrigger>
	// 			)}
	// 		</>
	// 	);
	// }, []);

	useEffect(
		() => {
			// setColumnDefsStaff([
			// 	...(userAccess.isAboveAuditor
			// 		? [
			// 				{
			// 					headerName: '',
			// 					headerTooltip: 'Rendicontato',
			// 					tooltipComponent: CustomTooltip,
			// 					field: 'reported',
			// 					cellRenderer: ReportedCheckRenderer,
			// 					cellRendererParams: {
			// 						queryParam: 'reported',
			// 					},
			// 					minWidth: 70,
			// 					maxWidth: 70,
			// 					//flex: 1,
			// 					resizable: false,
			// 					...columnCentered(),
			// 				},
			// 			]
			// 		: []),
			// 	...(userAccess.isAboveAuditor
			// 		? [
			// 				{
			// 					headerName: '',
			// 					headerTooltip: 'Eleggibile',
			// 					tooltipComponent: CustomTooltip,
			// 					field: 'reportable',
			// 					cellRenderer: TotalResumeChecklistCellRenderer,
			// 					cellRendererParams: {
			// 						queryParam: 'reportable',
			// 					},
			// 					minWidth: 70,
			// 					maxWidth: 70,
			// 					//flex: 1,
			// 					...columnCentered(),
			// 				},
			// 			]
			// 		: []),
			// 	{
			// 		headerName: 'Dipendente',
			// 		field: 'employee.keyValue',
			// 		filter: 'agTextColumnFilter',
			// 		cellStyle: { ...customCellStyle },
			// 		cellRendererParams: {
			// 			queryParam: 'serial_number',
			// 		},
			// 		flex: 1,
			// 	},
			// 	{
			// 		headerName: 'Anno',
			// 		field: 'year',
			// 		headerClass: 'text-center',
			// 		cellRendererParams: {
			// 			queryParam: 'year',
			// 		},
			// 		cellStyle: { ...customCellStyle, justifyContent: 'center' },
			// 		flex: 1,
			// 		maxWidth: 100,
			// 	},
			// 	{
			// 		headerName: 'Mese',
			// 		field: 'month',
			// 		headerClass: 'text-center',
			// 		cellStyle: { ...customCellStyle, justifyContent: 'center' },
			// 		valueGetter: (params) => {
			// 			return months()[params.data.month - 1];
			// 		},
			// 		cellRendererParams: {
			// 			queryParam: 'month',
			// 		},
			// 		flex: 1,
			// 	},
			// 	{
			// 		headerName: 'Categoria',
			// 		field: 'category',
			// 		filter: 'agTextColumnFilter',
			// 		cellStyle: {
			// 			...customCellStyle,
			// 		},
			// 		cellRendererParams: {
			// 			queryParam: 'category',
			// 		},
			// 		flex: 1,
			// 	},
			// 	{
			// 		headerName: 'Record',
			// 		field: 'timesheet',
			// 		cellRenderer: ResumeChecklistCellRenderer,
			// 		cellRendererParams: {
			// 			link: true,
			// 			setShow: setShow,
			// 			setApiToCall: setApiToCall,
			// 			queryParam: 'number',
			// 		},
			// 		minWidth: 230,
			// 		filter: 'agTextColumnFilter',
			// 		filterValueGetter: (params) => {
			// 			return params.data.timesheet.keyValue;
			// 		},
			// 		comparator: (valueA, valueB) => {
			// 			if (valueA.keyValue === valueB.keyValue) return 0;
			// 			return valueA.keyValue > valueB.keyValue ? 1 : -1;
			// 		},
			// 		flex: 1,
			// 	},
			// 	{
			// 		headerName: 'Beneficiario',
			// 		field: 'beneficiary.name',
			// 		minWidth: 170,
			// 		filter: 'agTextColumnFilter',
			// 		filterValueGetter: (params) => {
			// 			return params.data.beneficiary.name;
			// 		},
			// 	},
			// 	{
			// 		headerName: 'Costo totale €',
			// 		field: 'totalCost',
			// 		valueFormatter: (params) => {
			// 			return formatToDecimals(params.data.totalCost);
			// 		},
			// 		cellRendererParams: {
			// 			queryParam: 'total_cost',
			// 			typeOf: 'number',
			// 		},
			// 		filter: 'agTextColumnFilter',
			// 		filterParams: {
			// 			filterOptions: ['equals'],
			// 			textMatcher: ({ filterOption, value, filterText }) => {
			// 				if (filterText == null) return false;

			// 				switch (filterOption) {
			// 					case 'equals':
			// 						return value === filterText || formatToDecimals(Number(value)) === filterText;
			// 					default:
			// 						return false;
			// 				}
			// 			},
			// 		},
			// 		comparator: (_valueA, _valueB, nodeA, nodeB) => {
			// 			if (nodeA.data.totalCost === nodeB.data.totalCost) return 0;
			// 			return nodeA.data.totalCost > nodeB.data.totalCost ? 1 : -1;
			// 		},
			// 		flex: 1,
			// 		minWidth: 170,
			// 		...columnToRight(),
			// 	},
			// ]);

			setColumnDefsReports([
				{
					headerName: 'Voci di spesa',
					field: 'projectNoticeExpenseItemName',
					filter: 'agTextColumnFilter',
					//minWidth: 250,
					flex: 2,
				},
				{
					headerName: 'Avanzamento (€)',
					field: 'totalColors',
					filter: 'agTextColumnFilter',
					valueFormatter: (params) => {
						return params.data.totalColors > 0 ? formatToDecimals(params.data.totalColors) : '-';
					},
					filterValueGetter: (params) => {
						return params.data.totalColors > 0 ? formatToDecimals(params.data.totalColors) : '-';
					},
					valueGetter: (params) => {
						return params.data.totalColors > 0 ? params.data.totalColors : 0;
					},
					minWidth: 190,
					...columnToRight(),
				},
				{
					headerName: 'Eleggibile (€)',
					field: 'totalGreen',
					filter: 'agTextColumnFilter',
					valueFormatter: (params) => {
						return params.data.totalGreen > 0 ? formatToDecimals(params.data.totalGreen) : '-';
					},
					filterValueGetter: (params) => {
						return params.data.totalGreen > 0 ? formatToDecimals(params.data.totalGreen) : '-';
					},
					valueGetter: (params) => {
						return params.data.totalGreen > 0 ? params.data.totalGreen : 0;
					},
					minWidth: 190,
					...columnRightGreen,
				},
				{
					headerName: 'In lavorazione (€)',
					field: 'totalYellow',
					filter: 'agTextColumnFilter',
					valueFormatter: (params) => {
						return params.data.totalYellow > 0 ? formatToDecimals(params.data.totalYellow) : '-';
					},
					filterValueGetter: (params) => {
						return params.data.totalYellow > 0 ? formatToDecimals(params.data.totalYellow) : '-';
					},
					valueGetter: (params) => {
						return params.data.totalYellow > 0 ? params.data.totalYellow : 0;
					},
					minWidth: 190,
					...columnRightYellow,
				},
				{
					headerName: 'Non eleggibile (€)',
					field: 'totalRed',
					filter: 'agTextColumnFilter',
					valueFormatter: (params) => {
						return params.data.totalRed > 0 ? formatToDecimals(params.data.totalRed) : '-';
					},
					filterValueGetter: (params) => {
						return params.data.totalRed > 0 ? formatToDecimals(params.data.totalRed) : '-';
					},
					valueGetter: (params) => {
						return params.data.totalRed > 0 ? params.data.totalRed : 0;
					},
					minWidth: 190,
					...columnRightRed,
				},
			]);
		},
		[
			// ResumeChecklistCellRenderer,
			// TotalResumeChecklistCellRenderer,
			// ReportedCheckRenderer,
			// OnlyChecklistCellRenderer,
			// OnlyWarningCellRenderer,
			// userAccess,
			// project.sco,
			// project.streamConfigurationType,
			// project.advancedConfig,
		],
	);

	// const handleClick = (ref) => {
	// 	ref.current?.handleReset();
	// };

	return (
		<>
			<NavTabs
				tabNavItems={tabNavItems}
				// onValueChangeCallback={(key) => {
				// 	setFilteredTotal(null);
				// 	setIsFiltered(false);
				// 	handleClick(key === 'external-supplies' ? filter1Ref : filter2Ref);
				// 	// setModelFilterString('');
				// }}
			/>
			{/* {project && renderCorrectModal(apiToCall)} */}

			{hasEnabledAi && canViewAIDisclaimer ? (
				<Banner
					variant="blank"
					hasIcon={false}
					message={
						<p className="mb-0">
							Il controllo automatizzato basato su Intelligenza Artificiale viene configurato sulla base delle specifiche normative e della
							documentazione disponibile; tuttavia, eventuali anomalie nei dati o nei documenti caricati possono influire sull'esito
							dell'analisi.&nbsp;
							<span className="f-600">
								L'attività di verifica automatica costituisce un supporto decisionale al controllo umano, ma non lo sostituisce. I risultati
								devono essere oggetto di revisione e validazione da parte dell'utente o del team competente.
							</span>
						</p>
					}
					style={{ boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}
					className="col-11"
				/>
			) : null}
		</>
	);
};
export default ExecutionSummary;
